
export const formatBytes = (bytes:number, decimals = 2) => {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'B', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}


const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];


export function getFormattedDate(date:any, prefomattedDate?:any, hideYear?:any) {
  const day = date.getDate();
  const month = MONTH_NAMES[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours();
  let minutes = date.getMinutes();

  if (minutes < 10) {
    minutes = `0${ minutes }`;
  }

  if (prefomattedDate) {
    return `${ prefomattedDate } at ${ hours }:${ minutes }`;
  }

  if (hideYear) {
    return `${ day } ${ month } at ${ hours }:${ minutes }`;
  }

  return `${ day } ${ month } ${ year } at ${ hours }:${ minutes }`;
}

export const matchUrl = (str:string) => {

  const url = /^((https?:\/\/)|(\/)|(..\/))(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/gi
  return str.match(url)
}

export const matchEmailAddress = (str:string) => {

  const email = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi

  return str.match(email)
}

export function timeAgo(dateParam:any) {
    if (!dateParam) {
      return null;
    }

    const date = typeof dateParam === 'object' ? dateParam : new Date(dateParam);
    const DAY_IN_MS = 86400000;
    const today:any = new Date();
    const yesterday = new Date(today - DAY_IN_MS);
    const seconds = Math.round((today - date) / 1000);
    const minutes = Math.round(seconds / 60);
    const isToday = today.toDateString() === date.toDateString();
    const isYesterday = yesterday.toDateString() === date.toDateString();


    if (seconds < 5) {
        return 'now';
    } else if (seconds < 60) {
        return `${ seconds } seconds ago`;
    } else if (seconds < 90) {
        return 'about a minute ago';
    } else if (minutes < 60) {
        return `${ minutes } minutes ago`;
    } else if (isToday) {
        return getFormattedDate(date, 'Today');
    } else if (isYesterday) {
      return getFormattedDate(date, 'Yesterday');
    } 

    return getFormattedDate(date);
}


export const timestampToDateString = (timestamp:string):string => {
  
    const date = new Date(Date.parse(timestamp))

    const year = date.getFullYear().toString()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = (date.getDate()).toString().padStart(2, '0')
    const hour = (date.getHours()).toString().padStart(2, '0')
    const minute = (date.getMinutes()).toString().padStart(2, '0')

    return `${day}/${month}/${year} ${hour}:${minute}`
}

export const trainingDateStringConversion = (traningDate: string) => {
    const yyyy = traningDate.slice(0, 4)
    const MM   = traningDate.slice(4, 6)
    const dd   = traningDate.slice(6, 8)
    const hh   = traningDate.slice(9, 11)
    const min  = traningDate.slice(11, 13)

    return`${dd}/${MM}/${yyyy} ${hh}:${min}`
}
